<template>
  <PageWrapper
    :active-section="SECTION_MONETIZATION"
    :active-page="PAGE_MONETIZATION_DISPLAY_ADS"
    :breadcrumbs="breadcrumbs"
    page-name="Display Ads"
    align="left"
    width="fixed"
  >
    <iRow align="between" vertical-align="middle">
      <iHeading>Display Ads</iHeading>
      <iLink variant="tertiary" href="javascript:void(0)">
        Change Date Range
      </iLink>
    </iRow>
    <iDataTable
      :fields="displayAdsFields"
      :items="displayAdsItems"
      primary-key="adName"
      :has-more="false"
      :is-loading="false"
      hide-actions
    >
      <template #td="{data, value}">
        <iText :font-weight="data.adName === 'Total' ? 'dark' : 'standard'">
          {{ value }}
        </iText>
      </template>
    </iDataTable>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { SECTION_MONETIZATION, PAGE_MONETIZATION_DISPLAY_ADS } from "@/constants/nav-constants";
import { displayAdsFields, displayAdsItems } from "@/constants/monetization-fake-data";

export default {
  name: "DisplayAds",
  components: {
    PageWrapper,
  },
  data() {
    return {
      SECTION_MONETIZATION,
      PAGE_MONETIZATION_DISPLAY_ADS,
      displayAdsFields,
      displayAdsItems,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/monetization/org/${this.orgId}`, label: "Monetization" },
      ];
    },
  },
};
</script>

<style scoped></style>
